import RestfulService from "../common/RestfulService";
import assert from "utils/assert";

const reportDocService = new RestfulService("/issb/report-doc");

export default reportDocService;

/**
 * See TypedId.java e.g. "Round:123"
 * @typedef {string} TypedId
 */

/**
 * @typedef {Object} Citation
 * @property {string} title
 * @property {string} data-question_id The weaviate question id (use getWeaviateQuestion to get the question with it's "main" id = the SQL business_id)
 */

export class ReportDoc {
  id;
  title;
  content;
  /** @type {TypedId[]?} */
  sourcesAllowed;
  /** @type {string?} */
  questionFilter;
  /** @type {Date} */
  createdDate;
  updatedDate;
  createdBy;
  updatedBy;
}

/**
 * See TypedId.java
 * @param {*} type
 * @param {*} id
 * @returns {TypedId}
 */
export const typedId = (type, id) => {
  assert(type, "type is required");
  assert(id, "id is required");
  if (type === "IssbQuestionnaire") {
    // HACK
    type = "Round";
  }
  return `${type}:${id}`;
};

export const baseIdFromTypedId = (typedId) => {
  return typedId.indexOf(":") > 0 ? typedId.substring(typedId.indexOf(":") + 1) : typedId;
};

reportDocService.getHistory = async (reportDocId) => {
  return reportDocService.axios.get(`${reportDocService.path}/${reportDocId}/history`).then(({ data }) => data);
};
